/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IVendorShipperFacilityDataFragment = { __typename?: 'VendorShipperFacility' } & Pick<
  Types.IVendorShipperFacility,
  'id' | 'uuid' | 'vendorId'
> & {
    metadata?: Types.Maybe<
      { __typename?: 'FacilityMetadata' } & Pick<Types.IFacilityMetadata, 'addressLine2'>
    >
    shipperFacility: { __typename?: 'ShipperFacility' } & Pick<
      Types.IShipperFacility,
      'id' | 'uuid'
    > & {
        facility: { __typename?: 'Facility' } & Pick<Types.IFacility, 'id' | 'uuid'>
        shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
          Types.IShipperApplication,
          'id' | 'name'
        >
      }
    identifiers?: Types.Maybe<
      Array<
        { __typename?: 'FacilityIdentifier' } & Pick<
          Types.IFacilityIdentifier,
          'id' | 'facilityCode' | 'ediLocationCode' | 'vendorShipperFacilityUuid'
        >
      >
    >
  }

export const VendorShipperFacilityDataFragmentDoc = gql`
  fragment VendorShipperFacilityData on VendorShipperFacility {
    id
    uuid
    vendorId
    metadata {
      addressLine2
    }
    shipperFacility {
      id
      uuid
      facility {
        id
        uuid
      }
      shipperApplication {
        id
        name
      }
    }
    identifiers {
      id
      facilityCode
      ediLocationCode
      vendorShipperFacilityUuid
    }
  }
`
